export default __webpack_public_path__ + "static/media/2.ceca5a9f.jpg";